<template>
  <div>
    <CCard>
      <ProcessBarModal
          :show-modal="showModal"
          :step="step"
          :error-text="downloadError"
          :progress="progress"
          :steps-text="{creating: 'Report creation', success: 'Report created', error: 'Something went wrong'}"
          @close="() => showModal = false"
          :title="$t('Downloading file')"
      />
      <CCardHeader>
        {{ $t('Historical') }}
      </CCardHeader>
      <CCardBody>
        <CRow class="w-100">
          <CCol col="12" v-for="link in links">
            <CButton
                color="link"
                class="font-2xl custom-links"
                @click="downloadFile(link.report)"
            >
              {{ $t(`${link.label}`) }}
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {HISTORICAL_ENDPOINTS} from "@/services/historical";
import Task from "@/services/task";
import ProcessBarModal from "@/components/ProcessBarModal.vue";
import { request } from "@/utils/request";

export default {
  name: "Historical",
  components: {ProcessBarModal},
  data() {
    return {
      showModal: false,
      step: '',
      progress: 0,
      downloadError: '',
      HISTORICAL_ENDPOINTS,
      links: [
        {
          label: "Threshold history",
          report: "threshold_history"
        },
        {
          label: "Gareat prime historical",
          report: "prime_historical"
        },
        {
          label: "Collected premiums",
          report: "collected_premiums"
        }
      ]
    }
  },
  methods: {
    async downloadFile(selected_report) {
      this.downloadError = '';
      this.step = 'creating'
      this.progress = 0;
      this.showModal = true;

      this.progress = 25
      const { data } = await request({
        url: HISTORICAL_ENDPOINTS.historical,
        query: { selected_report }
      });
      this.progress = 50;
      if (data && !data.detail) {
        this.progress = 75;
        const task = new Task(data, 'xlsx');
        task.on('result', (result) => {
          if (result?.error) {
            this.step = 'error'
            this.uploadError = result.error
          }
          this.progress = 100;
          this.step = 'success';
          this.$downloadFile({ response: result })
        })

        task.on('error', (error) => {
          this.step = 'error'
          this.downloadError = error
        })
      }
      else {
        this.step = 'error'
        this.downloadError = data.detail || ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.custom-links {
  color: $primary;
  text-decoration: underline;

  &:hover {
    color: $text-secondary;
  }
}
</style>
